import BaseModel from './base-model';
import Course from "./course";

class Lesson extends BaseModel {
  constructor(data) {
    super(data);
    this.data = data;
  }

  set data(data) {
    super.data = data;

    this.scores         = parseInt(data['scores']);
    this.innerId        = parseInt(data['inner_id']);
    this.courseId       = parseInt(data['course_id']);

    this.hidden         = !!data['hidden'];

    this.title          = data['title'];
    this.text           = data['text'];
    this.description    = data['description'];

    this.createdAt      = data['created_at'];
    this.updatedAt      = data['updated_at'];

    this.image          = data['image'];
    this.preview        = data['preview'];

    this.course         = null;

    if (data['course']) {
      this.course = new Course(data['course']);
    }
  }

  get data() {
    return {
      id:                 this.id,
      scores:             this.scores,
      course_id:          this.courseId,
      inner_id:           this.innerId,
      hidden:           !!this.hidden,
      title:              this.title,
      text:               this.text,
      description:        this.description,
      image:              this.image,
      preview:            this.preview,
    }
  }
}

export default Lesson;
